import "tippy.js";

import "normalize.css";
import "tippy.js/dist/tippy.css";
import "./styles.css";
